'use client';

import { useRef } from 'react';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { cn } from '@/utils/cn';
import ProgressBarContent from './progress';
import { useStickyBelowHeader } from './use-sticky-below-header';
const StickyProgressBar = () => {
  const {
    isMobile
  } = useMobileDetect();
  const placeholderRef = useRef<HTMLDivElement>(null);
  const {
    isStuck,
    offsetPx
  } = useStickyBelowHeader(placeholderRef);
  return <>
            <div ref={placeholderRef} aria-hidden={isStuck} className={cn('relative z-10 -mb-2 -mt-5 overflow-hidden pb-2', {
      invisible: isStuck
    }, !isMobile && 'homepage-container')}>
                <div className='lg:border-gray-light flex w-full items-center gap-2 bg-white px-2 py-3 shadow-[0_1px_3px_rgb(0_0_0_/_0.12)] lg:border-b lg:px-0 lg:shadow-none'>
                    <ProgressBarContent data-sentry-element="ProgressBarContent" data-sentry-source-file="index.tsx" />
                </div>
            </div>

            {isStuck && <div className='fixed inset-x-0 z-10 -mb-2 overflow-hidden pb-2' style={{
      top: offsetPx
    }}>
                    <div className={cn(!isMobile && 'homepage-container')}>
                        <div className='lg:border-gray-light flex w-full items-center gap-2 bg-white px-2 py-3 shadow-[0_1px_3px_rgb(0_0_0_/_0.12)] lg:border-b lg:px-0 lg:pb-4 lg:pt-5 lg:shadow-none'>
                            <ProgressBarContent active />
                        </div>
                    </div>
                </div>}
        </>;
};
export default StickyProgressBar;